import {
  ApprovalStage,
  TransactionState,
  TransactionType,
  TransactionalState,
  ReceivedToken,
  PriceImpactState,
} from './interface'

import { BigNumber } from 'ethers'
import { ProductType } from 'sdk'

export const MAX_LOSS_MULTIPLIER = 10000
export const DEFAULT_SLIPPAGE = '0.03' // 3%
export const MAX_PRICE_IMPACT_PERCENT = '-0.05' // Flag if change is in excess of 0.5%

export const getDefaultToken = (token: string, decimals: number): ReceivedToken => {
  return {
    usdcPrice: '1',
    nativePrice: '1',
    token: token.toLocaleLowerCase(),
    decimals: decimals,
    target: '0x0',
    outputAmount: BigNumber.from(0),
  }
}

/**
 * This is the default transactional state value of the widget.
 * It will be updated based on user in put and information provided to it by the financial context
 */
export const initialPresentationalState: TransactionalState = {
  receivedTokens: [], // this is set in the transactional context before it is passed into the reducer
  selectedAsset: '', // this is set in the transactional context before it is passed into the reducer
  loadingValues: false,
  productAddress: '',
  productType: ProductType.INDEX_V1,
  transactionState: TransactionState.IDLE,
  runningTransaction: undefined,
  isBuying: true,
  isSwapState: false,
  fee: BigNumber.from(0),
  availableBalance: BigNumber.from(0),
  inputAssetAmount: '',
  inputIndexAmount: '',
  amountInputDollarValue: BigNumber.from(0),
  approvalStage: ApprovalStage.IDLE,
  transactableCoins: [],
  transactionType: TransactionType.AUTO,
  redemptionAsset: '',
  autoSlippage: true,
  modalOpen: false,
  isTokensReceivedModalOpen: false,
  priceImpactState: PriceImpactState.NONE,
  currentPriceImpactPercentage: '0',
  inputDollarValue: '',
  outputDollarValue: '',
  slippageTolerance: DEFAULT_SLIPPAGE,
  dispatch: () => {
    console.log('empty dispatch')
  },
}
